import styled from 'styled-components';

const TargetDateText = styled.text`
  font-family: Proxima Nova;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  text-anchor: middle;
`;

const YAxisText = styled.text`
  font-family: Proxima Nova;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  text-anchor: middle;
`;

export default {
  TargetDateText,
  YAxisText,
};
